import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StatementOfAccountDefault } from '@models/statementOfAccount';
import { StatementOfAccountDefaultsDispatch } from '@state/business/statementOfAccountDefaults';

export interface EditDocumentModalData {
	statement: StatementOfAccountDefault;
}

@Component({
	selector: 'app-edit-document-text',
	templateUrl: './edit-document-text.component.html',
	styleUrls: ['./edit-document-text.component.scss'],
	standalone: false,
})
export class EditDocumentTextComponent {
	public statement: StatementOfAccountDefault;
	private text;
	public _data;

	constructor(
		public dialogRef: MatDialogRef<EditDocumentTextComponent>,
		@Inject(MAT_DIALOG_DATA) public data: EditDocumentModalData,
		private statementOfAccountDispatch: StatementOfAccountDefaultsDispatch,
	) {
		this.statement = data?.statement;
	}

	cancel() {
		this.dialogRef.close();
	}

	save() {
		this.statementOfAccountDispatch.SetDocumentText(this.statement, this.text);
		this.dialogRef.close();
	}

	setDocumentHtmlText(text): void {
		this.text = text;
	}
}
